import React, {useState, useEffect} from 'react';
import { getIWGgame } from 'integrationActions.js';
import { translation } from 'helpers/utilsHelper.js';
import { useDispatch } from 'react-redux'
import S from 'StyledInstantWinGame.js';

const InstantWinGame = (props) => {

    const { provider, gameName, gameId } = props;

    const dispatch = useDispatch()
    const [gameIframeUrl, setGameIframeUrl] = useState('');

    useEffect(() => {
        fetchGameIframeUrl();
    }, []);

    const fetchGameIframeUrl = async () => {
        const realPlay = true;
        const response = await dispatch(getIWGgame(gameId, realPlay));
        if (response) { 
            setGameIframeUrl(response);
        }
    }

    const goToGamesList = () => {
        app.router.redirect('/instantWinGames');
    }

    return (
        <S.InstantWinGameWrapper>
            <S.GameNameRow> 
                <S.BackBtn onClick={() => goToGamesList()}> {translation('instantWinGames_back')} </S.BackBtn>
                <S.GameName> {decodeURIComponent(`${gameName}`)} </S.GameName> 
            </S.GameNameRow>
            <S.PlayerWrapper>
                <iframe 
                    key={gameIframeUrl}
                    className="player"
                    title={`${provider}-${gameId}`}
                    src={gameIframeUrl}>
                </iframe>
            </S.PlayerWrapper>
        </S.InstantWinGameWrapper>
    )
}

export default InstantWinGame;